import { createActionTypes } from 'utils/action/actionTypes';

export const FETCH_WALLET_TOP_UP_OFFERS = createActionTypes('FETCH_WALLET_TOP_UP_OFFERS');
export const SAVE_WALLET_TOP_UP_OFFERS = createActionTypes('SAVE_WALLET_TOP_UP_OFFERS');
export const DELETE_WALLET_TOP_UP_OFFER = createActionTypes('DELETE_WALLET_TOP_UP_OFFER');
export const FETCH_WALLET_TOP_UP_OFFER_HISTORY = createActionTypes('FETCH_WALLET_TOP_UP_OFFER_HISTORY');
